let ImgViewerDefaultOptions = {
  inline: true,
  backdrop: false,
  navbar: false,
  button: false,
  title: false,
  fullscreen: false,
  minHeight: 600,
  minWidth: 650,
  toolbar: {
    zoomIn: { show: true },
    zoomOut: { show: true },
    rotateLeft: { show: true },
    rotateRight: { show: true },
    reset: { show: true }
  }
}

export {
  ImgViewerDefaultOptions
}
